import React, { useState, useEffect } from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import ServicesSection from "./ServicesSection";
import FeaturesSection from "./FeaturesSection";
import CTASection from "./CTASection";
import Footer from "./Footer";
import WhatsAppWidget from "./WhatsAppWidget";
import CookieBanner from "./CookieBanner";

const HomePage = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(() => {
    return !localStorage.getItem('cookiesAccepted');
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <HeroSection />
      <ServicesSection />
      <FeaturesSection />
      <CTASection />
      <Footer />
      <WhatsAppWidget />
      {showCookieBanner && (
        <CookieBanner onClose={() => setShowCookieBanner(false)} />
      )}
    </div>
  );
};

export default HomePage;